import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';

import FavoriteIcon, { favoriteActionTitle } from '../FavoriteIcon';
import { CompactActionButton } from './styles';

const ICON_SIZE = 18;

/**
 * A card's favorite control, the card-sized twin of the hero pages'
 * FavoriteButton.
 */
export default function CardFavoriteAction({ isFavorite, onToggle, className }) {
  if (!onToggle) {
    if (!isFavorite) return null;
    return (
      <Box
        className={className}
        title={favoriteActionTitle(true)}
        sx={{ display: 'flex', alignItems: 'center', padding: '4px' }}
      >
        <FavoriteIcon isFavorite size={ICON_SIZE} />
      </Box>
    );
  }

  return (
    <CompactActionButton
      className={className}
      title={favoriteActionTitle(isFavorite)}
      onClick={onToggle}
    >
      <FavoriteIcon isFavorite={isFavorite} size={ICON_SIZE} />
    </CompactActionButton>
  );
}

CardFavoriteAction.propTypes = {
  isFavorite: PropTypes.bool,
  onToggle: PropTypes.func,
  className: PropTypes.string,
};

CardFavoriteAction.defaultProps = {
  isFavorite: false,
  onToggle: null,
  className: undefined,
};
